import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An7(props) {
    const { nodes } = useGLTF('3ds/an/An7.gltf');

    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An7) {
                        global.gw.geometries.An7 = e.geometry;
                    }
                }}
                name="An7"
                geometry={nodes.An7.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An7.gltf');